import { render, staticRenderFns } from "./declaration.vue?vue&type=template&id=72233c8c&scoped=true"
import script from "./declaration.vue?vue&type=script&lang=js"
export * from "./declaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72233c8c",
  null
  
)

export default component.exports